<template>
  <div class="about-page-headline">
    <h2
      class="about-page-headline__title"
      :class="`about-page-headline__title--${colorClass}`"
    >
      {{ displayTitle }}
    </h2>
    <p v-if="subTitle.length > 0" class="about-page-headline__sub-title">
      {{ displaySubtitle }}
    </p>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  subTitle: {
    type: String,
    required: false,
    default: ''
  },
  colorClass: {
    type: String,
    required: false,
    default: 'primary'
  }
})

const displayTitle = ref('')
const displaySubtitle = ref('')

onMounted(() => {
  // 改行しない場合の表示で空白が入らないよう空白文字を削除する対応
  const isMobile = window.matchMedia('(max-width: 767px)').matches
  const isPc = window.matchMedia('(min-width: 1024px)').matches
  displayTitle.value = isMobile ? props.title : props.title.replace(/\n/g, '')
  displaySubtitle.value = isPc
    ? props.subTitle.replace(/\n/g, '')
    : props.subTitle
})
</script>

<style lang="scss" scoped>
.about-page-headline {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  &__title {
    font-weight: bold;
    font-size: 4.4rem;
    line-height: 1.6;

    @media all and (max-width: ($pc-width  - 1)) {
      font-size: 2.8rem;
    }

    @media all and (max-width: ($base-contents-width  - 1)) {
      white-space: pre-wrap;
    }

    &--primary {
      color: $primary;
    }

    &--white {
      color: $white;
    }
  }

  &__sub-title {
    font-size: 2rem;
    line-height: 1.6;
    text-align: center;

    @media all and (max-width: ($pc-width  - 1)) {
      font-size: 1.4rem;
      white-space: pre-wrap;
    }
  }
}
</style>
